import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FeatureNewsCarouselComponent } from './feature-news-carousel/feature-news-carousel.component';
import { SwiperDirective } from '@usheru-hff/shared/ui-swiper';
import { NewsUiNewsCardCommunityModule } from '@usheru-hff/news/ui-news-card-community';
import { ButtonModule } from 'primeng/button';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';
import { SharedUiArrowModule } from '@usheru-hff/shared/ui-arrow';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    SwiperDirective,
    ButtonModule,
    NewsUiNewsCardCommunityModule,
    SharedUtilsModule,
    SharedUtilsTranslationModule,
    SharedUiArrowModule
  ],
  declarations: [FeatureNewsCarouselComponent],
  exports: [FeatureNewsCarouselComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NewsFeatureNewsCarouselModule {}
